/** Presence-animated overlay so mist rails hide on exit, not after unmount. */
export function overlayPresenceProps(visible: boolean): {
  'data-wp-overlay': '';
  'data-wp-overlay-open'?: '';
} {
  return visible
    ? { 'data-wp-overlay': '', 'data-wp-overlay-open': '' }
    : { 'data-wp-overlay': '' };
}

/**
 * Stack band for body-fixed mist rails.
 * Page mist stays under dropdowns/tips; floating/overlay/tooltip elevate to match host.
 */
export type MistRailStack = 'page' | 'floating' | 'overlay' | 'tooltip';

export function mistRailStack(el: HTMLElement): MistRailStack {
  if (el.matches('[role="tooltip"]') || el.closest('[role="tooltip"]')) return 'tooltip';
  if (el.closest('[data-wp-overlay-open], [role="dialog"]')) return 'overlay';
  if (
    el.closest(
      '[role="menu"], [role="listbox"], [data-wp-popover-content], [data-wp-portal]',
    )
  ) {
    return 'floating';
  }
  return 'page';
}

/** Apply stack band as data attr for CSS z-index bands in scrollbar.css. */
export function applyMistRailStack(rail: HTMLElement, el: HTMLElement): void {
  rail.dataset.wpMistStack = mistRailStack(el);
}

/** True when a mist rail must not paint for this scroll container. */
export function shouldHideMistRail(el: HTMLElement): boolean {
  if (!el.isConnected) return true;
  const overlay = el.closest('[data-wp-overlay]');
  if (overlay && !overlay.hasAttribute('data-wp-overlay-open')) return true;
  /* Collapsed Mise en route / Configuration initiale keep DOM; hide mist. */
  if (el.closest('[aria-expanded="false"]')) return true;
  if (el.closest('[aria-hidden="true"]')) return true;

  /*
   * Open modal/drawer overlays sit above page chrome. Page mist uses a low
   * z-index band; still hide rails for scrollers outside the top open overlay
   * so thumbs do not float mid-dialog (e.g. setup list under confirm modal).
   */
  const openOverlays = document.querySelectorAll('[data-wp-overlay-open]');
  if (openOverlays.length > 0) {
    const top = openOverlays[openOverlays.length - 1]!;
    const isDoc = el === document.documentElement || el === document.body;
    if (isDoc || !top.contains(el)) return true;
  }

  if (typeof el.checkVisibility === 'function') {
    return !el.checkVisibility({ checkOpacity: true, checkVisibilityCSS: true });
  }
  return false;
}
